import { render } from "./register.vue?vue&type=template&id=c97f8748"
import script from "./register.vue?vue&type=script&lang=js"
export * from "./register.vue?vue&type=script&lang=js"
script.render = render

export default script